import SearchTitleV2Provider from './hooks/useSearchTitleV2';

import { SearchTitleV2Props } from './@types/SearchTitleV2Props';
import Content from './handles/Content';

const SearchTitleV2 = (props: SearchTitleV2Props) => (
	<SearchTitleV2Provider {...props}>
		<Content />
	</SearchTitleV2Provider>
);

export default SearchTitleV2;
